import Long from 'long';
import { bigIntToLong, longToBigInt } from '#common/util';
import { CounterRequestMsg, ServiceBaseProto } from '#websocket/client/proto';
const COUNTER_REQUEST_TYPE = '.CounterRequestMsg.counterRequest';
const COUNTER_RESPONSE_TYPE = '.CounterResponseMsg.counterResponse';
export class IncrementCounterRequest {
    name;
    increment;
    destination;
    constructor(name, increment, destination) {
        this.name = name;
        this.increment = increment;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const counterRequest = CounterRequestMsg.create({
            operation: CounterRequestMsg.OperationType.INCREMENT_COUNTER,
            counterName: this.name,
            counterValue: new Long(this.increment),
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [COUNTER_REQUEST_TYPE]: counterRequest,
        });
    }
    createResponse(responseMessage) {
        return new IncrementCounterResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
export class IncrementCounterResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        const result = responseMsgObject[COUNTER_RESPONSE_TYPE].counterValue;
        this.result = longToBigInt(result);
    }
}
